<form>
  <div class="sb-question">
    <mat-progress-bar mode="determinate" [value]="percentage()"></mat-progress-bar>
    <mat-stepper #stepper>
      @for (question of form.questions; track question.index; let first = $first) {
      <mat-step>
        <div [id]="'js-page0'+question.index" class="page">
          <img [src]="question.imgSrc" alt="" class="sb-question__img lazyload" />
          <h2 class="sb-question__title u-text-center">
            <span>Q.{{ question.index }}</span>{{ question.title }}
          </h2>
          @for (choice of question.choices; track choice.value) {
          <div class="sb-question__wrapper">
            <label class="sb-question__label">
              <input type="radio" [(ngModel)]="form[question.name]" [value]="choice.value" [name]="question.title" (click)="next(question)">
              <span [innerHTML]="choice.label"></span>
            </label>
          </div>
          }
        </div>
      </mat-step>
      }
      <mat-step>
        <div class="page">
          <div class="u-text-center">
            <h2 class="sb-checking__title">診断中</h2>
            <p class="sb-checking__text">まもなく診断結果が表示されます</p>
            <div class="sb-checking__spinner">
              <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330410/bc72c852-6e05-4a1f-b5e1-6ac1ae561d87.svg" alt="○" class="lazyload">
            </div>
            <img src="https://file.mysquadbeyond.com/uploads/article_photo/photo/5330409/43072b65-1402-46f2-8d74-94a20b1b28c3.png" alt="" class="loading-img lazyload">
          </div>
        </div>
      </mat-step>
    </mat-stepper>
    @if (stepper.selectedIndex !== stepper.steps.length - 1) {
      <button class="sb-footer__btn" (click)="prev()">一つ前に戻る</button>
    }
  </div>
</form>
